import { useEffect, useState } from "react";
import SideDrawerShell from "../../common/components/SideDrawerShell";
import { defectsApi } from "../api/defectsApi";
import "../../../V2SideDrawer.css";
import "../../common/styles/QuickViewDrawer.css";

function fmtDate(val) {
  if (!val) return "—";
  const d = new Date(val);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
}

export default function DefectQuickViewDrawer({ defectId, onClose }) {
  const [defect, setDefect] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!defectId) return;
    let cancelled = false;
    setLoading(true);
    setError("");
    setDefect(null);
    defectsApi.getById(defectId)
      .then((data) => { if (!cancelled) setDefect(data); })
      .catch(() => { if (!cancelled) setError("Failed to load defect details."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [defectId]);

  return (
    <SideDrawerShell
      open={!!defectId}
      onClose={onClose}
      subtitle="DEFECT"
      title={defect?.defect_code || "Defect"}
      width="min(560px, 100vw)"
      footer={defect ? (
        <a className="qv-open-full" href={`/defectsv2new?openDefectId=${defect.id}`} target="_blank" rel="noreferrer">
          Open full view →
        </a>
      ) : null}
    >
      {loading && <div className="qv-state">Loading…</div>}
      {!loading && error && <div className="qv-state qv-state--error">{error}</div>}
      {!loading && !error && defect && (
        <div className="qv-fields">
          <div className="qv-field qv-field--full">
            <span className="qv-label">Title</span>
            <span className="qv-value">{defect.title || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Status</span>
            <span className="qv-value">{defect.status || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Severity</span>
            <span className="qv-value">{defect.severity || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Priority</span>
            <span className="qv-value">{defect.priority || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Customer</span>
            <span className="qv-value">{defect.customer_name || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Project</span>
            <span className="qv-value">{defect.project_name || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Assigned To</span>
            <span className="qv-value">{defect.assigned_to_name || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Reported By</span>
            <span className="qv-value">{defect.reported_by_name || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Due Date</span>
            <span className="qv-value">{fmtDate(defect.due_date)}</span>
          </div>
          <div className="qv-field qv-field--full">
            <span className="qv-label">Description</span>
            <span className="qv-value qv-value--multiline">{defect.description || "—"}</span>
          </div>
        </div>
      )}
    </SideDrawerShell>
  );
}
